import React from "react";
import Tooltip from "../../common/tooltip/main";

export default class WatermarkSettings extends React.Component {
  state = {
    hasUpload: false,
    uploading: false
  };

  get watermarkGrid() {
    let gridBoxes = [];
    for (var i = 0; i < 9; i++) {
      gridBoxes.push(
        <div
          key={i}
          value={i}
          className={
            i === this.props.selectedGridBox
              ? "grid-box selected"
              : this.props.selectedGridBox === "full"
                ? "grid-box selected"
                : "grid-box"
          }
          onClick={e => this.selectGrid(Number(e.target.getAttribute("value")))}
        />
      );
    }
    return gridBoxes;
  }

  selectGrid(value) {
    this.props.updateWatermark(value, "selectedGridBox");
    switch (value) {
      case 0:
        this.props.updateWatermark("north_east", "watermarkPosition");
        break;
      case 1:
        this.props.updateWatermark("north", "watermarkPosition");
        break;
      case 2:
        this.props.updateWatermark("north_west", "watermarkPosition");
        break;
      case 3:
        this.props.updateWatermark("west", "watermarkPosition");
        break;
      case 4:
        this.props.updateWatermark("center", "watermarkPosition");
        break;
      case 5:
        this.props.updateWatermark("east", "watermarkPosition");
        break;
      case 6:
        this.props.updateWatermark("south_west", "watermarkPosition");
        break;
      case 7:
        this.props.updateWatermark("south", "watermarkPosition");
        break;
      case 8:
        this.props.updateWatermark("south_east", "watermarkPosition");
        break;
      default:
        this.props.updateWatermark("center", "watermarkPosition");
        break;
    }
  }

  handleNoFileUpload() {
    this.setState({ hasUpload: false, uploading: false });
    this.props.updateWatermark("", "watermarkUrl");
    this.props.updateWatermark(false, "showWaterMark");
  }

  updateWatermark(e) {
    this.setState({ uploading: true });
    if ($("input.watermark-upload")[0].files.length === 0) {
      this.handleNoFileUpload();
      console.log("No file selected");
      return;
    }
    let fd = new FormData(this.refs.watermarkForm);
    fd.append("upload_preset", "brandfolder_watermark");
    fd.append("folder", BF.fx.slug());
    $.ajax({
      url: "https://api.cloudinary.com/v1_1/brandfolder/image/upload",
      type: "POST",
      data: fd,
      processData: false,
      contentType: false,
      context: this,
      success: function(response) {
        console.log("succesfully uploaded watermark");
        this.setState({ hasUpload: true, uploading: false });
        this.props.updateWatermark(
          response["public_id"],
          "watermarkUrl",
          response["version"]
        );
        let scaleFactor = response.width / response.height;
        this.props.updateWatermark(scaleFactor, "watermarkScaleFactor");
        this.props.updateWatermark(response.height, "watermarkHeight");
        this.props.defaultWatermarkDuration();
        this.props.updateWatermark(true, "showWaterMark");
        if (this.props.selectedGridBox < 0) {
          this.props.updateWatermark(6, "selectedGridBox");
        }

        Notify.create({ title: "Watermark uploaded!", type: "success" });

        // Google Analytics
        BF.fx.dataLayerPush({
          brandfolder: BF.fx.slug(),
          event: "AdvancedVideoWatermarkUpload"
        });
      },
      error: function(xhr) {
        console.log("upload failed");
        this.handleNoFileUpload();
        Notify.create({
          title:
            "Watermark upload failed! Please ensure your file is an image and try again.",
          type: "errror"
        });
      }
    });
  }

  changeOpacity(e) {
    this.props.updateWatermark(e.target.value, "opacity");
  }

  changeHeight(e) {
    this.props.updateWatermark(Number(e.target.value), "watermarkHeight");
  }

  uploadForm() {
    if (this.state.uploading) {
      return <div> Uploading </div>;
    }
    return (
      <form ref="watermarkForm">
        <input
          className="full watermark-upload"
          type="file"
          name="file"
          encType="multipart/form-data"
          onChange={this.updateWatermark.bind(this)}
        />
      </form>
    );
  }

  setFullGrid() {
    this.props.updateWatermark("full", "selectedGridBox");
    this.props.updateWatermark("center", "watermarkPosition");
    this.props.updateWatermark(this.props.videoHeight, "watermarkHeight");
  }

  valueFormattedCorrectly(value) {
    if (value.toString().indexOf(":") > 0) {
      for (var i = 0; i < value.split(":").length; i++) {
        let getSegmentValue = Number(value.split(":")[i]);
        if (isNaN(getSegmentValue)) {
          return false;
        }
      }
    } else if (isNaN(Number(value)) && value != "") {
      return false;
    }
    return true;
  }

  updateDelay(e) {
    if (
      this.valueFormattedCorrectly(e.target.value) &&
      this.props.watermarkUrl
    ) {
      this.props.updateWatermark(e.target.value, "watermarkDelay");
    } else {
      Notify.create({
        title: "Please upload a watermark image first",
        type: "error"
      });
    }
  }

  updateDuration(e) {
    if (
      this.valueFormattedCorrectly(e.target.value) &&
      this.props.watermarkUrl
    ) {
      this.props.updateWatermark(e.target.value, "watermarkDuration");
    } else {
      Notify.create({
        title: "Please upload a watermark image first",
        type: "error"
      });
    }
  }

  render() {
    return (
      <div className="watermark-settings">
        <div
          className="full watermark-button"
          style={{ padding: "10px 0px 5px 0px", fontWeight: "bold" }}
        >
          Watermark Options &nbsp;
          <Tooltip
            tooltipId="watermark-info"
            tooltipContent="Overlay an image onto this video, then selectively adjust the image's size, opacity, position, or time of appearance/disappearance."
          >
            <i className="fa fa-question-circle" />
          </Tooltip>
        </div>
        <div className="open exapandable-container">
          <div className="full video-watermark video-input-wrap">
            <div className="video-label full">Watermark Image </div>
            <form ref="watermarkForm" className="float-left">
              <input
                className="full watermark-upload"
                type="file"
                name="file"
                encType="multipart/form-data"
                onChange={this.updateWatermark.bind(this)}
              />
            </form>
            {this.state.uploading ? (
              <div
                className="float-left"
                style={{ paddingLeft: "5px", color: "#40d1f5" }}
              >
                {" "}
                Upload in progress ...{" "}
              </div>
            ) : (
              ""
            )}
            <div
              className={
                this.state.hasUpload
                  ? "open watermark-options"
                  : "hide watermark-options"
              }
            >
              <div className="full video-clip video-input-wrap">
                <div className="flex-half">
                  <div className="video-label full">
                    {" "}
                    Watermark Delay &nbsp;
                    <Tooltip tooltipName="Time at which the watermark image appears.">
                      <i className="fa fa-question-circle" />
                    </Tooltip>
                  </div>
                  <input
                    className="full"
                    type="text"
                    value={this.props.watermarkDelay}
                    onChange={this.updateDelay.bind(this)}
                    onBlur={this.props.checkWatermarkDelay.bind(this)}
                  />
                </div>
                <div className="flex-half">
                  <div className="video-label full">
                    {" "}
                    Watermark Duration &nbsp;
                    <Tooltip tooltipName="Time at which the watermark image disappears. (defaults to end of video)">
                      <i className="fa fa-question-circle" />
                    </Tooltip>
                  </div>
                  <input
                    className="full"
                    type="text"
                    value={this.props.watermarkDuration}
                    onChange={this.updateDuration.bind(this)}
                    onBlur={this.props.checkWatermarkDuration.bind(this)}
                  />
                </div>
              </div>
              <div className="full video-input-wrap">
                <div className="video-label full">
                  <div className="float-left">Watermark size</div>
                  <div className="float-right">
                    {this.props.watermarkHeight}
                  </div>
                </div>
                <input
                  type="range"
                  name="watermarkHeight"
                  value={this.props.watermarkHeight}
                  min="30"
                  max={this.props.videoHeight}
                  step="10"
                  onChange={this.changeHeight.bind(this)}
                />
                <div className="video-label full">
                  <div className="float-left">Watermark opacity</div>
                  <div className="float-right">{this.props.opacity}</div>
                </div>
                <input
                  type="range"
                  name="bgopacity"
                  value={this.props.opacity}
                  min="0"
                  max="100"
                  step="1"
                  onChange={this.changeOpacity.bind(this)}
                />
              </div>

              <div
                className="video-label full"
                style={{ width: "99%", maxWidth: "400px" }}
              >
                <div className="float-left">
                  Watermark Placement &nbsp;
                  <Tooltip
                    tooltipId="watermark-position-info"
                    tooltipContent="Click a section within the grid or full screen to position the watermark."
                  >
                    <i className="fa fa-question-circle" />
                  </Tooltip>
                </div>
                <a
                  className="float-right"
                  onClick={this.setFullGrid.bind(this)}
                >
                  Full Screen
                </a>
              </div>
              <div className="video-grid">{this.watermarkGrid}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
